/* ================================================== */
/* ANGULARJS > Routes
/* ================================================== */

app.config(['$routeProvider', '$locationProvider', function($routeProvider, $locationProvider) {
	$locationProvider.html5Mode(true);
	$routeProvider
		.when('/admin/entries/works/:workSlug', {
			controller: 'mainController',
		})
		.when('/works/:workSlug', {
			controller: 'mainController',
		})
		.when('/contact', {
			controller: 'mainController',
		})
		.when('/', {
			controller: 'mainController',
		});
}]);
